import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";

const NotificationsPage = Loadable(
  lazy(() =>
    import("./NotificationsPage").then(({ NotificationsPage }) => ({
      default: NotificationsPage,
    })),
  ),
);

const NotificationSettings = Loadable(
  lazy(() =>
    import("./NotificationSettings").then(({ NotificationSettings }) => ({
      default: NotificationSettings,
    })),
  ),
);

export const notificationRoutes = [
  { path: "/notifications", exact: true, element: <NotificationsPage /> },
  { path: "/notifications/settings", exact: true, element: <NotificationSettings /> },
];
